import styles from "./Banner.module.css";

const Banner = ({ name, description, bannerImage, fields }) => {
  function removeTags(str) {
    if (str === null || str === "") return false;
    else str = str.toString();

    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/gi, "");
  }

  const cleanedDesc = description.replace(
    /&nbsp;|\u00a0/g,
    " ",
  );

  return (
    <div className={styles.container}>
      <img src={bannerImage} className={styles.img} alt="" />
      <div className={styles.body}>
        <h1 className={styles.name}>{name}</h1>
        <p
          className={styles.description}
          dangerouslySetInnerHTML={{__html: cleanedDesc}}
        />
      </div>
    </div>
  );
};

export default Banner;
